export default __webpack_public_path__ + "static/media/sharebanner.225f8445.png";